import axiosInstance from "./api_helper";

const invoiceSupplierService = {
    search: async ({ companyId, fournisseurId, dateFrom, dateTo, query }) => {
        const response = await axiosInstance.get('/api/factures-fournisseur/search', {
            params: { companyId, fournisseurId, dateFrom, dateTo, query }
        });
        return response.data;
    },

    searchInvoiceSummary: async (query) => {
        return axiosInstance.post(`/api/suppliers/invoice-summaries`, JSON.stringify(query));
    },   

    getNewInvoiceNumber: async () => {
        return await axiosInstance.get(`/api/factures-fournisseur/nouveau`);
    },

    addInvoice: async (invoiceData) => {
        return await axiosInstance.post('/api/factures-fournisseur/generate-consolidated', invoiceData);
    },

    addPayment: async (paymentData) => {
        return await axiosInstance.post('/api/supplier/payments', paymentData);
    },

    generateDocument: async (id) => {
        const response = await axiosInstance.get(`/api/supplier/invoices/report/${id}`, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    generateReleve: async (query) => {
        const response = await axiosInstance.post(`/api/supplier/invoices/releve`, JSON.stringify(query), {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    deleteInvoice: async (invoiceId) => {
        const response = await axiosInstance.delete(`/api/supplier/invoices/${invoiceId}`);
        return response.data;
    },

    filterInvoice: async (query) => {
        return axiosInstance.post(`/api/supplier/invoices/search`, JSON.stringify(query));
    },

    getLastSavedInvoice: async () => {
        return await axiosInstance.get(`/api/supplier/invoices/last-saved`);
    },

    updateInvoice: async (invoiceId, invoiceData) => {
        return await axiosInstance.put(`/api/factures-fournisseur/${invoiceId}`, JSON.stringify(invoiceData));
    },

    getInvoiceReglements: async (numero) => {
        return await axiosInstance.get(`/api/factures-fournisseur/reglement/${encodeURIComponent(numero)}`);
    },

    cancelInvoice: async (invoiceId, motifAnnulation) => {
        try {
            const response = await axiosInstance.post(`/api/factures-fournisseur/${invoiceId}/annuler?motifAnnulation=${encodeURIComponent(motifAnnulation)}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

}

export default invoiceSupplierService;
